<style lang="less" scoped>
</style>
<template>
  <div class="">
    <Modal
      v-model="is_show"
      title="关联固定资产"
      width="900"
      cancel-text=""
      ok-text="关闭"
      @on-ok="cancel"
    >
      <div class="line">
        <h3>已关联固定资产:</h3>
        <Table
          size="small"
          :columns="linked_asset_columns"
          :data="linked_assets"
        />
      </div>
      <i-input
        v-model="params.search"
        placeholder="搜索固定资产"
        @on-enter="search"
      >
        <Button
          slot="append"
          icon="ios-search"
          :loading="searching"
          @click="search"
        >
          搜索
        </Button>
      </i-input>
      <div
        v-if="search_assets.length"
        class="line"
      >
        <div class="line">
          <h3>搜索结果: </h3>
        </div>
        <Table
          size="small"
          :columns="search_columns"
          :data="search_assets"
        />
      </div>
    </Modal>
    <Modal
      v-model="is_show_link"
      title="关联付款项"
      @on-ok="doLink"
    >
      <Form
        ref="form"
        :model="payment_params"
      >
        <FormItem
          label="付款项"
          prop="selected_expense_id"
          :rules="{ required: true, message: '必选'}"
        >
          <Select
            v-model="payment_params.selected_expense_id"
            placeholder="请选择付款项"
            :rules="{ required: true, message: '必选'}"
            @change="payment_params.expense_team_id=null"
          >
            <Option
              v-for="expense in expenses"
              :key="expense.id"
              :value="expense.id"
            >
              {{ expense.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          v-show="payment_params.selected_expense_id"
          label="团队"
          prop="expense_team_id"
          :rules="{ required: true, message: '必选'}"
        >
          <Select
            v-model="payment_params.expense_team_id"
            placeholder="请选择团队"
          >
            <Option
              v-for="team in selected_expense.expense_teams"
              :key="team.id"
              :value="team.id"
            >
              {{ teams_hash&&teams_hash[team.team_id]&&teams_hash[team.team_id].name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          label="关联金额"
          prop="payment"
          :rules=" [{
            required: true,
            message: '必选'
          },{ validator: validatePass, trigger: 'blur' }]"
        >
          <Input
            v-model="payment_params.payment"
            type="number"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="is_show_link=false"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="link_loading"
          @click="doLink"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  const createPaymentParams = () => ({
    asset_id:null,
    selected_expense_id: null,
    expense_team_id: null,
    payment: null
  })
  export default {
    props: {
      linked_assets: {
        type: Array,
        default: () => []
      },
      expenses: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selected_asset: null,
        // link_price: 0,
        // selected_expense_id: 0,
        is_show: false,
        is_show_link: false,
        searching: false,
        link_loading: false,
        payment_params: createPaymentParams(),
        del_loading_selected: null,
        params: {
          search: ''
        },
        search_assets: [],
        linked_asset_columns: [{
          title: '操作',
          align: 'center',
          fixed: 'left',
          render: (h, params) => {
            const row = params.row;
            return h('Button', {
              props: {
                size: 'small',
                type: 'warning',
                loading: this.del_loading_selected === row.id
              },
              on: {
                click: () => {
                  this.delLinkAsset(row, params.index);
                }
              }
            }, '删除');
          }
        }, {
          title: '资产编号',
          align: 'center',
          key: 'uid'
        }, {
          title: '所属付款项目',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.expense_name)
          }
        }, {
          title: '费用类别',
          align: 'center',
          render: (h, params) => {
            const type = this.expense_types_hash[params.row.expense_type_id];
            return h('div', type ? type.full_name : '-')
          }
        }, {
          title: '型号',
          align: 'center',
          key: 'asset_model'
        }, {
          title: '设备类型',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.asset_device_type ? params.row.asset_device_type.name : '无')
          }
        }, {
          title: '项目组',
          align: 'center',
          render: (h, params) => {
            return h('div', this.teams_hash[params.row.team_id].name)
          }
        }, {
          title: '用途',
          align: 'center',
          key: 'purpose'
        }, {
          title: '供应商',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', params.row.payee_company.name)
          }
        }, {
          title: '购入价格',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.price)
          }
        }, {
          title: '付款额',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.payment)
          }
        }],
        search_columns: [{
          title: '操作',
          align: 'center',
          fixed: 'left',
          render: (h, params) => {
            const row = params.row;
            return h('Button', {
              props: {
                size: 'small',
                type: 'primary',
                disabled: this.isInAssets(row)
              },
              on: {
                click: () => {
                  this.linkToAsset(row);
                }
              }
            }, '关联');
          }
        }, {
          title: '资产编号',
          align: 'center',
          key: 'uid'
        }, {
          title: '设备类型',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.asset_device_type ? params.row.asset_device_type.name : '无')
          }
        }, {
          title: '型号',
          align: 'center',
          key: 'asset_model'
        }, {
          title: '公司',
          align: 'center',
          render: (h, params) => {
            return h('div', this.companies_hash[params.row.company_id].name)
          }
        }, {
          title: '项目组',
          align: 'center',
          render: (h, params) => {
            return h('div', this.teams_hash[params.row.team_id].name)
          }
        }, {
          title: '用途',
          align: 'center',
          key: 'purpose'
        }, {
          title: '资产类型',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row && params.row.asset_type && params.row.asset_type.name || '-')
          }
        }, {
          title: '供应商',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.payee_company ? params.row.payee_company.name : '')
          }
        }, {
          title: '购入价格',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.price)
          }
        }]
      }
    },
    computed: {
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
        expense_types_hash: 'async/expense_types_hash',
      }),
      selected_expense() {
        const expenses_hash = (this.expenses || []).reduce((t, i) => {
          t[i.id] = i
          return t
        }, {})
        const expense = expenses_hash[this.payment_params.selected_expense_id] || {}
        return expense || {}
      }
    },
    created() {

    },
    methods: {
      validatePass(rule, value, callback) {
        if (Number(value) > parseFloat(this.selected_asset.price)) {
          callback(new Error(`金额不能大于固定资产价格(${this.selected_asset.price}元)`));
        } else {
          callback()
        }
      
      },
      cancel() {
        this.is_show = false;
      },
      isInAssets(asset) {
        // this.$util.api(this.$ajax)
        return this.linked_assets.find(linked_asset => linked_asset.id === asset.id) !== undefined
      },
      linkToAsset(asset) {
        this.selected_asset = asset
        this.$refs.form.resetFields()
        this.is_show_link = true
        setTimeout(() => {
          this.payment_params = createPaymentParams()
          this.payment_params.asset_id = asset.id
          this.payment_params.payment = asset.price
        }, 200)
      },
      doLink() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // const asset = this.selected_asset
            const expense = this.selected_expense
            // const expense_team = expense.expense_teams.find(expense_team => expense_team.team_id === asset.team_id)
            // if (!expense_team) {
            //   this.$Message.error('该付款项所含团队与固定资产所属团队不匹配!');
            //   return
            // }
            const {selected_expense_id, ...params} = this.payment_params
            // console.log('asset_id', asset.team_id, this.expenses)
            // console.log('expense_team_id', expense_team.id)
            // console.log('payment', this.link_price)
            this.link_loading = true
            this.$util.ajax.post(this.$util.api.add_asset_expense_team, params).then(res => {
              if (res.data.code === 1) {
                this.$Message.success('关联成功!')
                this.$emit('linked', Object.assign(res.data.data, {
                  expense_type_id: expense.expense_type_id,
                  expense_id: expense.id,
                  expense_name: expense.name
                }))
                this.is_show_link = false
                this.$emit('getDetail')
              } else {
                this.$Message.error('关联失败:' + res.data.msg)
              }
            }).catch(e => {
              this.$Message.error(e.message)
            }).finally(() => {
              this.link_loading = false
            })
          }
        })
      // this.$util.post(this.$util)
      },
      delLinkAsset(asset, index) {
        // return this.$util.ajax.post()
        this.del_loading_selected = asset.id
        this.$util.ajax.post(this.$util.api.delete_asset_expense_team, {
          expense_team_id: asset.expense_team_id,
          asset_id: asset.id
        }).then(res => {
          if (res.data.code === 1) {
            this.$Message.success('关联删除成功!')
            this.linked_assets.splice(index, 1)
            this.$emit('getDetail')
          } else {
            this.$Message.error('关联失败:' + res.data.msg)
          }
        }).catch(e => {
          this.$Message.error(e.message)
        }).finally(() => {
          this.del_loading_selected = null
        })
      },
      search() {
        this.searching = true
        this.$util.ajax(this.$util.api.query_asset_search, {
          params: {
            search: this.params.search
          }
        }).then(res => {
          if (res.data.code === 1) {
            this.searching = false
            this.search_assets = res.data.data
          } else {
            this.$Message.error('搜索失败:', res.data.msg)
          }
        }).catch(e => {
          this.$Message.error(e.message)
        })
      },
      init() {
        this.is_show = true
      }
    }
  }
</script>
